import Route from 'cio/routes/base';
import SegmentModel from 'cio/models/segment';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';

export default class SegmentPeopleRoute extends Route {
  model() {
    return this.modelFor('segments.segment');
  }

  // Using "any" instead of the actual controller because the controller has
  // queryParams definitions that aren't compatible with Ember's typescript
  // definitions (which are defined incorrectly)
  setupController(controller: any, model: SegmentModel, transition: Transition) {
    super.setupController(controller, model, transition);

    if (model.isBuilding) {
      controller.pollForBuildFinish.perform();
    } else {
      controller.fetchMembershipMetrics.perform();
    }
  }

  resetController(controller: any, isExiting: boolean, transition: any) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.fetchMembershipMetrics.cancelAll({ resetState: true });
      controller.setDefaults();
    }
  }

  @action
  didTransition() {
    (this.controller as any).set('source', null);
    return true;
  }
}
